(function() {

    var $body = $('body');
    var isHome = $body.hasClass('home');

    var $window = $(window);
    var windowWidth = $window.width();

    var isMobile = windowWidth < 480;
    var isTablet = windowWidth < 768;
    var isDesktop = ! isMobile && ! isTablet;

    /**
     * Menu
     */

    $('.js-menu-toggle').on('click', function(e) {
        e.preventDefault();
        var $this = $(this);
        var $navigation = $('.header__navigation');

        $this.toggleClass('is-active');

        $('body').toggleClass('no-scroll');

        setTimeout(function() {
            $this.toggleClass('inverse');
        }, 250);

        $navigation.stop().fadeToggle().toggleClass('is-active');
    });

    $(document).keyup(function(e) {
        var $navigation = $('.header__navigation');
        if (e.keyCode === 27 && $navigation.hasClass('is-active')) { // Hit eccape key
            $('.js-menu-toggle').click();
        }
    });

    /**
     * Banner logo opacity
     */

    $(window).on('scroll', function () {

        var scrollTop = $(window).scrollTop();

        var $el = $('.banner__logo');
        var elHeight = $el.height();

        $el.css({
            'opacity': (elHeight - (scrollTop / 10)) / elHeight
        });

        var $el = $('.banner__content__copy');
        var elHeight = $el.height();

        $el.css({
            'opacity': (elHeight - (scrollTop / 2)) / elHeight
        });

    });


    /**
     * Testimonials carousel
     */

    $('.js-slider').slick({
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        centerMode: true,
        infinite: true,
        prevArrow: '<button type="button" class="slick-prev link link--inline link--left">Prev</button>',
        nextArrow: '<button type="button" class="slick-next link link--inline link--right">Next</button>'
    });


    function initWcProductGallery() {

        var number_slides = $('.woocommerce-product-gallery__wrapper .woocommerce-product-gallery__image').length;

        $('.woocommerce-product-gallery__wrapper').not('.slick-initialized').slick({
            slide: '.woocommerce-product-gallery__image',
            dots: (number_slides > 1) ? true : false,
            arrows: false,
            slidesToScroll: 1,
            slidesToShow: 1,
            speed: 1000,
            infinite: false
        });
    }

    // initWcProductGallery();

    $('form.variations_form').on('wc_additional_variation_images_frontend_image_swap_done_callback', function (data) {
        // setTimeout(function() {
            initWcProductGallery();

            initFancybox();

            $('.woocommerce-product-gallery__image').each(function (index, item) {
                const $link = $(item).find('.attachment-shop_single').data('large_image');
                $(item).find('a').attr('href', $link);
            });
        // }, 10);
    })

    /**
     * Reveal items on scroll
     */

    // $(window).on('scroll', function() {
    //     $('.animate-in').each(function(index, item) {
    //         var $el = $(item);
    //         var elemTop = $el.offset().top;
    //         var elemBottom = elemTop + $el.height();
    //         var offset = $el.hasClass('animated-in--half-screen') ? ($(window).height() / 3) : null;

    //         if ($el.visible(offset)) {
    //             $el.addClass('animate-in--visible');
    //             setTimeout(function() {
    //                 $el.addClass('animate-in--done');
    //             }, 500)
    //         }
    //     });
    // });

    // $(window).trigger('scroll');


    /**
     * Parallax
     */

    // if (isDesktop)
    // {
    //     $('.js-parallax').each(function(i, el) {
    //         $(el).parallax('50%', 0.15);
    //     });
    // }


    /**
     * Modal
     */

    $('.js-trigger-modal').on('click', function(e) {
        e.preventDefault();
        $('.modal').fadeIn(500, function() {
            // $(this).addClass('is-loaded');
        });
        $('.modal').addClass('is-loaded');
    });

    $('.js-dismiss-modal').on('click', function(e) {
        e.preventDefault();
        $('.modal').fadeOut(500, function() {
            $(this).removeClass('is-loaded');
        });
    });


    /**
     * Video modal
     */

    $('.js-play-video').on('click', function(e) {
        e.preventDefault();

        // Pause current video
        // var $current_video = $('.section__column__media__player');
        // if ($current_video.length) {  $current_video.get(0).pause(); }

        // Append modal
        var modal = '<div class="modal modal--video">' +
                        '<div class="modal__overlay js-dismiss-modal"></div>' +
                        '<a href="#" class="modal__dismiss js-dismiss-modal">&times;</a>' +
                        '<div class="modal__content">' +
                            '<div class="modal__video">' +
                                '<iframe src="' + $(this).attr('href') + '?title=0&byline=0&portrait=0&autoplay=1" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' +
                            '</div>' +
                        '</div>' +
                    '</div>';

        $(modal).insertAfter('.footer');

        $('.modal--video').fadeIn();

        $('.modal--video').fitVids();

        // Dismiss and remove modal
        $('.js-dismiss-modal').on('click', function(e) {
            e.preventDefault();
            $('.modal--video').fadeOut(500, function() {
                $(this).remove();
                // $current_video.get(0).play();
            });
        });
    });


    /**
     * Griddle
     */

    $('.griddle-switch').on('click', function(e) {
        e.preventDefault();
        $('.griddle').toggle();
    });

    /**
     * Fancybox
     */
    function initFancybox() {
        $('[data-fancybox]').fancybox({
            buttons : [ 'zoom', 'close' ]
        });
    }
    initFancybox();

    /**
     * Send as a Gift
     */

    $('[name="send_as_a_gift"]').on('change', function() {
        if ($(this).is(':checked')) {
            $('#woocommerce-gift_fields').slideDown();
        }
        else
        {
            $('#woocommerce-gift_fields').slideUp();
        }
    });


    /**
     * Category filter
     */

    var $grid = $('.section--products .isotope').imagesLoaded( function() { 
        $grid.isotope({
          itemSelector: '.product',
          layoutMode: 'fitRows'
        });
    });

    $('.list--categories a').on( 'click', function(e) {
        e.preventDefault();
        $('.list--categories a').parent().removeClass('current');
        $(this).parent().addClass('current');
        var filterValue = $(this).attr('href');
        filterValue = filterValue.replace('#', '.');
        if (filterValue == '.all') { filterValue = '*'; }
        $('.section--products .container').isotope({
            filter: filterValue
        });
    });

    $('.js-basket').on('click', function (event) {
        event.preventDefault();

        if ($('.basket').length) {
            $('.basket').toggleClass('js-active');
            $('body').toggleClass('basket-open');
        }
    });

    $('.js-close-basket').on('click', function (event) {
        event.preventDefault();

        $('.basket').removeClass('js-active');
        $('body').removeClass('basket-open');
    });

    function recently_viewed_vairation() {
        $.ajax({
            type: "post",
            dataType: "json",
            url: woocommerce_params.ajax_url,
            data: {
                action: 'lm_recently_viewed_variation',
                variation_id: $('input.variation_id').val()
            },
            success: function (response) {
                // console.log(response);
                if (response.type == 'success') {
                    // console.log(repsonse);
                }
            }
        });
    }

    $('.variations_form').on('woocommerce_variation_has_changed', function () {
        recently_viewed_vairation();
    });

    $(document).ready(function () {
        setTimeout(function() {
            var variation_check = $('input.variation_id');
            if (variation_check.length && variation_check.val()) {
                recently_viewed_vairation();
            }
        }, 1000);
    });


    /**
     * Product add-ons
     */

    $(document).ready(function(){
        $('.product-addon-monogramming select').val('none-1');
        $('.product-addon-monogramming select').find('option').eq(0).remove();
    });

})($);

$(window).on('load', function() { 

    /**
     * Header
     */

    var headroomElement = document.querySelector("header");

    var options = {
        onPin: function() {
            
        },
        onUnpin: function() {
            $('.header').removeClass('header--inverted');
        }
    };

    var headroom  = new Headroom(headroomElement, options);

    /**
     * Soft scroll
     */

    const locomotive = new LocomotiveScroll({
        el: document.querySelector('[data-scroll-container]'),
        smooth: true,
        getDirection: true,
    });

    /**
     * Scroll down
     */

    $('.js-scroll-down').on('click', function(e) {
        e.preventDefault();
        locomotive.scrollTo( $('.banner').outerHeight() );
    });

    // Trigger if in-view
    locomotive.on('call', (value, way, obj) => {

        setTimeout(function(){
            $('.animate-in', $('.is-inview').parents('section')).addClass('animate-in--visible');
        }, 500);

    });

    // Headroom

    locomotive.on('scroll', (instance) => {
        
        var scrollTop = instance.scroll.y;

        if (instance.direction == 'up')
        {
            headroom.pin();
        }
        else if (instance.direction == 'down' && scrollTop > 0)
        {
            headroom.unpin();
        }

    });

    // Parallax section fade from grey to white

    locomotive.on('scroll', (obj) => {
        
        var scrollTop = obj.scroll.y;
        var scrollBottom = scrollTop + $(window).height();

        // Parallax sections

        $('.section--two-across-parallax').each(function() {

            var top = $(this).data('top');

            // console.log(top);

            var height = $(this).height();

            // Double speed; get to full colour change halfway down the section by multiplying by 2

            var percentage_scroll = (Math.max( (scrollBottom - top) / height, 0) * 2);

            var alpha = (percentage_scroll > 1 ? 1 : percentage_scroll);
            var channel = Math.round(247 + (alpha * 8));

            $(this).css('background-color', 'rgb(' + channel + ',' + channel + ',' + channel + ')');

        });

        // Header colour

        if ($('.banner').length && scrollTop > $('.banner').height()
            || $('.woocommerce-page').length && $(window).scrollTop() > $('.banner').height()) {
            $('.header').addClass('header--inverted');
        }
        else
        {
            $('.header').removeClass('header--inverted');
        }

    });

    // Fix to extra gap that would be left at bottom of page

    $(window).scroll();

    $('.section--two-across-parallax').each(function() {

        var pos = $(this).position();
        var top = pos.top;

        $(this).data('top', top);

    });

});